"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withThemeAndResponsive = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _context = require("../context");

var _utils = require("../utils");

var _StencilResponsiveConsumer = _interopRequireDefault(require("./StencilResponsiveConsumer"));

var _core = require("@emotion/core");

var withThemeAndResponsive = function withThemeAndResponsive(_ref) {
  var sizes = _ref.sizes,
      mapper = _ref.mapper;
  return function (WrappedComponent) {
    (0, _utils.showDeprecationWarning)({
      deprecatedName: 'withThemeAndResponsive',
      replacementName: 'the `useBreakpoints` hook',
      docsLink: 'https://stencil.a2z.com/for-developers/responsiveness'
    }); // Returned component takes all the props from P, but props in MP
    // are now optional since they are provided by the mapper.

    var ResponsiveComponent = function ResponsiveComponent(props) {
      return (0, _core.jsx)(_StencilResponsiveConsumer.default, {
        sizes: sizes
      }, function (_ref2) {
        var matches = _ref2.matches;
        return (0, _core.jsx)(WrappedComponent, (0, _extends2.default)({}, mapper({
          matches: matches
        }), props));
      });
    }; // Wrap the component and read the breakpoint from the theme


    var HoistedComponent = (0, _hoistNonReactStatics.default)(ResponsiveComponent, WrappedComponent); // Set display name

    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    HoistedComponent.displayName = "Responsive".concat(displayName); // Filter props
    // eslint-disable-next-line react/forbid-foreign-prop-types

    if (WrappedComponent.propTypes) {
      HoistedComponent.propTypes = (0, _utils.omit)(WrappedComponent.propTypes, [].concat((0, _toConsumableArray2.default)(_context.STENCIL_CONTEXT_PROPS), ['matches']));
    } // Forward withComponent from styled components


    var _ref3 = WrappedComponent,
        withComponent = _ref3.withComponent;

    if (withComponent !== undefined) {
      HoistedComponent.withComponent = function (tag) {
        return withThemeAndResponsive({
          sizes: sizes,
          mapper: mapper
        })(withComponent(tag));
      };
    }

    return ResponsiveComponent;
  };
};

exports.withThemeAndResponsive = withThemeAndResponsive;